module.exports = __webpack_public_path__ + "img/be-prepared.f28ce3ad.png";